/* eslint-disable no-unused-vars */
import { AjaxError } from 'rxjs/ajax';
import { action } from 'typesafe-actions';
import { Action, ActionCreator } from 'redux';
import { types } from './session.types';
import { IPublicUserTrackingInfo, IDeviceInfo } from './session';
import { Paths } from 'routes';
import { makePost } from 'services';
import { clearThumbnailToken } from 'components/partials/thumbnail/token-store';
import { clearCurrentUser } from 'services/current-user/current-user.service';

const storeCustomerCode: ActionCreator<Action<string>> = (customerCode: string) => action(types.STORE_CUSTOMER_CODE_SUCCESS, customerCode);
const storeUnsupportedBrowser: ActionCreator<Action<string>> = (unsupportedBrowser: boolean) =>
  action(types.STORE_UNSUPPORTED_BROWSER, unsupportedBrowser);
const storeUseNativeCamera: ActionCreator<Action<string>> = (useNativeCamera: boolean) =>
  action(types.STORE_USE_NATIVE_CAMERA, useNativeCamera);
const storeDeviceInfo: ActionCreator<Action<string>> = (deviceInfo: IDeviceInfo) =>
  action(types.STORE_DEVICE_INFO, deviceInfo);

const logoutSuccessful: ActionCreator<Action> = () => action(types.LOG_OUT_SUCCESS);

const logoutFailed: ActionCreator<Action<string>> = (payload: string) => action(types.LOG_OUT_FAILURE, payload);

const logout = (onSuccessDispatch?: Function, onErrorDispatch?: Function) => (dispatch: (arg0: Action<any>) => void) => {
  dispatch(action(types.LOG_OUT_STARTED));

  makePost('session/logout', {}).subscribe(
    () => {
      if (onSuccessDispatch) onSuccessDispatch();
      clearThumbnailToken();
      clearCurrentUser();
      window.location.replace(Paths.home);
      dispatch(logoutSuccessful());
    },
    ({ response: { error } }: AjaxError) => {
      if (onErrorDispatch) onErrorDispatch();
      dispatch(logoutFailed(error as string));
    }
  );
};

const startRecordingUserSession: ActionCreator<Action> = () => action(types.START_RECORDING_USER_SESSION);
const setPublicUserTrackingInfo: ActionCreator<Action<string>> = (publicUserTrackingInfo: IPublicUserTrackingInfo) =>
  action(types.SET_PUBLIC_USER_TRACKING_INFO, publicUserTrackingInfo);

export {
  storeCustomerCode, logout,
  storeUnsupportedBrowser, storeUseNativeCamera, storeDeviceInfo,
  startRecordingUserSession, setPublicUserTrackingInfo
};
